import { render, staticRenderFns } from "./symptom_manifestation.vue?vue&type=template&id=ed2f265a&scoped=true&"
import script from "./symptom_manifestation.vue?vue&type=script&lang=js&"
export * from "./symptom_manifestation.vue?vue&type=script&lang=js&"
import style0 from "./symptom_manifestation.vue?vue&type=style&index=0&id=ed2f265a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2f265a",
  null
  
)

export default component.exports